import React from 'react';
import { TiCode } from 'react-icons/ti';

interface IFrameCodeButtonProps {
  onOpenIFrameCodeModal: () => void;
}

export const IFrameCodeButton: React.FC<IFrameCodeButtonProps> = ({ onOpenIFrameCodeModal }) => {
  return (
    <button
      className='toolbar-button'
      onClick={onOpenIFrameCodeModal}
      title='iFrameコード'
      type='button'
    >
      <TiCode />
    </button>
  );
};
